<template>
  <div>
    <ul
      ref="productListNode"
      class="lg:cursor-none"
      @mouseover="isHovering = true"
      @mouseleave="isHovering = false"
    >
      <li
        v-for="(product, index) in data"
        :key="index"
        class="relative mb-4 pb-8 after:absolute after:bottom-0 after:h-[17px] after:w-full after:bg-[url(/assets/images/backgrounds/slashes.png)] after:bg-repeat last:mb-0 last:after:h-0"
      >
        <NuxtLink
          class="flex items-center justify-between gap-4 text-blue transition-colors duration-300 hover:text-orange lg:cursor-none"
          :to="localePathByType(product.__typename, product.slug as string)"
        >
          <span class="text-2xl font-light lg:text-8xl">{{ product.product }}</span>
          <Image
            v-if="product.productImage"
            class="aspect-3/2 max-w-[104px] rounded-3xl object-cover lg:max-w-none"
            loading="lazy"
            :src="
              product.productImage.responsiveImage
                ? product.productImage.responsiveImage?.src
                : product.productImage.url
            "
            :srcset="
              product.productImage.responsiveImage
                ? product.productImage.responsiveImage?.webpSrcSet
                : undefined
            "
            :width="
              product.productImage.responsiveImage
                ? product.productImage.responsiveImage?.width
                : product.productImage.width
            "
            :height="
              product.productImage.responsiveImage
                ? product.productImage.responsiveImage?.height
                : product.productImage.height
            "
            :sizes="product.productImage.responsiveImage?.sizes"
            :alt="product.productImage.alt!"
          />
        </NuxtLink>
      </li>
    </ul>
    <CustomCursor v-if="isHovering" />
  </div>
</template>

<script setup lang="ts">
import type { ProgramProductRecord } from '~/types/generated'
const { localePathByType } = useLocalePathByType()
const isHovering = ref(false)

defineProps({
  data: {
    type: Array as PropType<ProgramProductRecord[]>,
    default: () => []
  }
})
</script>
